import React from 'react'

const Error = () => {
  return (
    <div className='flex flex-row items-center justify-center text-white mx-auto my-auto'>
      Error-404 found
    </div>
  )
}

export default Error
